import styled from 'styled-components';

export const Container = styled.header`
  width: 100%;
  display: flex;
  padding: 1rem;
  grid-area: header;
  position: absolute;
  align-items: center;
  background: var(--background-header);
  justify-content: space-around;
  max-height: 79px;
  .hidden {}

  .boxLogo {
    width: 138px;
    height: 48px;
  }

  @media (max-width: 820px) {
    width: max(100%, 378px);
    justify-content: space-between;
    padding-left: 5%;
    .boxLogo{
      width: auto;
    }
    .hidden{
      display: none;
    }
    .hiddenMobile{
      display: block;
      margin-left: 5%;
    }
  }

  @media (min-width: 820px) {
    .hidden{
      /* display: none; */
    }
    .hiddenMobile{
      display: none;
    }
  }
`;
